export enum EAuthorProtocolsView {
	PENDING = 0,
	LIST = 1,
	COLUMN = 2,
}
